<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
              <v-toolbar flat>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="title">
                        {{ promotionCode }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-toolbar>
              <v-list class="pt-0">
                <v-divider></v-divider>
                <v-list-tile v-for="item in globalSideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action v-if="item.name === 'promotionFactors'">
                    <v-icon :class="isMatchRoute('promotionFactorReview') ? 'primary--text':''">{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-action v-else>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content v-if="item.name === 'promotionFactors'">
                    <v-list-tile-title :class="isMatchRoute('promotionFactorReview') ? 'primary--text':''">{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-content v-else>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view ></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { PROMOTION_SIDEMENU } from '@/store/types'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      breadcrumb: [],
      sideMenu: [
        { name: 'promotionReview', text: 'Promotion', icon: 'mdi-star' }
      ],
      newPromotion: false
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName',
      'checkAccess'
    ]),
    title() {
      if (this.newPromotion) {
        return 'New Promotion'
      } else {
        return 'Review Promotion'
      }
    },
    globalSideMenu() {
      return this.$store.state.promotionManagement.promotion.sideMenu
    },
    promotionCode() {
      if (this.promotion) {
        return this.promotion
      } else {
        return 'New Promotion'
      }
    }
  },
  methods: {
    ...mapActions([
      'promotionInit'
    ]),
    async doInit() {
      if (!this.newPromotion) {
        await this.promotionInit(this.promotion)
        this.sideMenu.push({ name: 'promotionFactors', text: 'Factor/Rates', icon: 'mdi-sale' })
        if (this.$store.state.promotionManagement.promotion.cardPromo) {
          this.sideMenu.push({ name: 'promotionCreditCardReview', text: 'Credit Card List', icon: 'mdi-credit-card-multiple' })
        }
        if (this.$store.state.promotionManagement.promotion.couponPromo) {
          this.sideMenu.push({ name: 'promotionCouponReview', text: 'Coupons', icon: 'mdi-ticket-percent' })
        }
        if (this.$store.state.promotionManagement.promotion.usrGrpPromo) {
          this.sideMenu.push({ name: 'promotionMemberGroupReview', text: 'Member Groups', icon: 'mdi-account-card-details' })
        }
      }
      this.$store.commit(PROMOTION_SIDEMENU, this.sideMenu)
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  beforeMount() {
    if (this.promotion === 'New') {
      this.newPromotion = true
    } else {
      // this.sideMenu.push({ name: 'campaignPromotionReview', text: 'Promotions', icon: 'mdi-star' })
      // this.sideMenu.push({ name: 'productCampaignReview', text: 'Products', icon: 'mdi-cube-outline' })
    }
    // Manual breadcrumb
    this.breadcrumb = this.derieveBreadcrumbByName('promotions')
    this.breadcrumb.push({
      name: 'promotionReview',
      text: this.title
    })
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
</style>
